import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { CENTERS, DISTRICTS, TALUKAS, VILLAGES, DROPDOWNS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(CENTERS.BASE);

// Export service with additional custom methods
export const CenterService = {
  ...baseCRUD,

  // Get dropdown options
  getDistricts: () => fetchDropdowns(DISTRICTS.ADMIN),

  getTalukas: async (districtId = '') => {
    const query = districtId
      ? TALUKAS.BY_DISTRICT(districtId)
      : TALUKAS.ADMIN;
    const response = await api.get(query);
    return response.data;
  },

  getVillages: async (talukaId = '') => {
    const query = talukaId
      ? VILLAGES.BY_TALUKA(talukaId)
      : VILLAGES.ADMIN;
    const response = await api.get(query);
    return response.data;
  },

  getStatuses: () => fetchDropdowns(CENTERS.STATUSES),
  getRoles: () => fetchDropdowns(CENTERS.ROLES),
  getAllDropdown: () => fetchDropdowns(DROPDOWNS.VILLAGES_WITH_LOCATION),
};

export default CenterService;
